/*
  Copyright 2018 Google LLC

  Use of this source code is governed by an MIT-style
  license that can be found in the LICENSE file or at
  https://opensource.org/licenses/MIT.
*/

export const BROADCAST_UPDATE_MESSAGE_TYPE = "CACHE_UPDATED";
export const BROADCAST_UPDATE_MESSAGE_META = "serwist-broadcast-update";
export const BROADCAST_UPDATE_DEFAULT_NOTIFY = true;
export const BROADCAST_UPDATE_DEFAULT_HEADERS = ["content-length", "etag", "last-modified"];
